<template>
  <div class="scanredirect-page">
    <div class="content">
      <van-cell-group class="item-row">
        <van-cell @click="handleNavigation('help')">

          <div slot="title">
            <div style="display: flex;align-items: center">
              <van-icon name="/static/images/icon/help.svg" />
              <div class="text-content">
                <div class="text-title">{{ $t('append_field.help') }}</div>
                <div class="text-subtitle">{{ $t('append_field.network_import') }} {{ $t('append_field.mobile_mode') }} {{ $t('append_field.standalone_mode') }}</div>
              </div>
            </div>
            <span class="cell-right"> <van-icon name="arrow"/> </span>
          </div>
        </van-cell>
        <van-cell @click="handleNavigation('apk')">

          <div slot="title">
            <div style="display: flex;align-items: center">
              <van-icon name="/static/images/icon/APK.svg" />
              <div class="text-content">
                <div class="text-title">{{ $t('append_field.apk_download') }}</div>
                <div class="text-subtitle">{{ $t('append_field.android') }}  {{ $t('append_field.ios') }}</div>
              </div>
            </div>
            <span class="cell-right"> <van-icon name="arrow"/> </span>
          </div>
        </van-cell>
        <van-cell @click="handleNavigation('h5')">

          <div slot="title">
            <div style="display: flex;align-items: center">
              <van-icon name="/static/images/icon/h5.svg" />
              <div class="text-content">
                <div class="text-title">{{ $t('append_field.app_name') }}</div>
                <div class="text-subtitle">{{ $t('append_field.info_publish') }} {{ $t('append_field.send_command') }} {{ $t('append_field.upload_material') }} </div>
              </div>
            </div>
            <span class="cell-right"> <van-icon name="arrow"/> </span>
          </div>
        </van-cell>
        <van-cell @click="handleNavigation('download')">

          <div slot="title">
            <div style="display: flex;align-items: center">
              <van-icon name="/static/images/icon/download.svg" />
              <div class="text-content">
                <div class="text-title">{{ $t('append_field.video_tutorial') }}</div>
                <div class="text-subtitle">{{ $t('append_field.video_tutorial') }} </div>
              </div>
            </div>
            <span class="cell-right"> <van-icon name="arrow"/> </span>
          </div>
        </van-cell>
      </van-cell-group>

    </div>

  </div>
</template>

<script>

export default {
  data() {
    return {
      language: '',
      channel: '',
      clientInfo: '',
      deviceName: ''
    }
  },
  mounted() {
    let lang = (navigator.language || navigator.browserLanguage).toLowerCase()
    // 将 zh-cn, zh-tw 等转换为 zh
    if(!lang || lang.startsWith('en-')) {
      lang = 'en'
    }
    if (lang.startsWith('zh-')) {
      lang = 'zh'
    }

    this.language = lang
  },
  methods: {
    /**
     * 统一处理页面跳转
     * @param {String} type - 跳转类型: 'help' 使用帮助, 'apk' APK下载, 'h5' H5助手下载
     */
    handleNavigation(type) {
      const routeMap = {
        help: {
          url: '/Help',
          query: { lang: this.language }
        },
        apk: {
          url: 'https://appstore.esoncloud.com/#/appDownload',
          query: { lang: this.language, id: '63' }
        },
        h5: {
          url: '/login',
        },
        download:{
          url: '/myExplain',
          query:{type:'phone'}
        }
      }
      
      const route = routeMap[type]
      if (route) {
        // 构建完整URL
        let targetUrl = route.url
        if (route.query) {
          const queryString = Object.keys(route.query)
            .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(route.query[key])}`)
            .join('&')
          // 判断URL中是否已有参数
          const separator = targetUrl.includes('?') ? '&' : '?'
          targetUrl = `${targetUrl}${separator}${queryString}`
        }
        // 使用 window.open 在新标签页打开，或者使用 window.location.href 在当前页面跳转
        if(type === 'apk'){
          window.open(targetUrl, '_blank')
        }else {

          this.$router.push({
            path: targetUrl,
            query: route.query,
          })
        }

      } else {
        console.warn(`未知的跳转类型: ${type}`)
      }
    }
  },
}
</script>

<style lang="scss">
@import "../../public/static/css/app";

.scanredirect-page {
  .content {
    height: 100%;

    .topPic {
      height: 130px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      background: #006EFF;
      color: #fff;

      .van-image {
        border-radius: 50%;
        overflow: hidden;
      }
    }

    .dataWrap {
      background: #006EFF;
      color: #fff;
      height: 4rem;
      border-top: 1px solid #fff;

      .nut-col {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height: 100%;
        overflow: hidden;

        &:first-child {
          border-right: 1px solid #fff;
        }

        span {
          width: 100%;
          word-wrap: break-word;
          text-align: center;
          max-height: 40px;
          overflow: hidden;
        }
      }
    }

    .item-row {
      margin: 10px 0;
      background: #fff;

      .cell-right {
        float: right;
      }

      .van-icon {
        font-size: 18px;
        margin-right: 4px;
        img{
          width: 30px;
          height: 30px;
          margin-right: 10px;
        }
      }

      .van-empty{
        display: flex;
        align-items: flex-end;
        justify-content: center;
      }
      .text-content {
        flex: 1;
        display: flex;
        flex-direction: column;
      }

      .text-title {
        font-weight: 600; /* 加粗 */
        color: #323233;
        font-size: 16px;
        line-height: 1.5;
        margin-bottom: 2px;
      }

      .text-subtitle {
        font-weight: 400; /* 正常粗细 */
        color: #646566;
        font-size: 13px; /* 比标题小 */
        line-height: 1.4;
        opacity: 0.8; /* 稍微透明 */
      }
    }
    .van-cell{
      padding: 20px ;
    }
    .van-cell__title {
      & > div {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }

    }

  }
  .addr{
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    max-width: 180px;
  }
  .bigBtn {
    padding: 0 20px;

    .van-button--large {
      border-radius: 40px;
    }
  }
  .contact{
    .van-field__body{
      border-bottom: #131212 1px solid;
    }
    .van-field__label{
      width: 100%;
    }
    .van-cell{
      display: flex;
      flex-direction: column;
    }
  }
  .select-groupings{
    .van-cell{
      padding: 20px;
    }
    .language{
      height: 300px;
      overflow-y: auto;
    }
  }
  [class*=van-hairline]::after{
    border: none;
  }
}
</style>
